import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    traficLight: {
      marginLeft: 48,
      display: 'flex',
    },
    signal: {
      margin: '0 8px',
      padding: '0 24px',
      fontFamily: 'Roboto',
      fontSize: 13,
      textTransform: 'none',
      boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
      whiteSpace: 'nowrap',
      '&:hover': {
        opacity: 0.9,
      },
    },
    statusOk: {
      color: 'rgb(255, 255, 255)',
      background: '#4cd964',
      '&:hover': {
        background: '#4cd964',
      },
    },
    statusError: {
      color: 'rgb(255, 255, 255)',
      background: '#ff3b30',
      '&:hover': {
        background: '#ff3b30',
      },
    },
    statusWarning: {
      background: '#ffcc00',
      color: '#000000',
      '&:hover': {
        background: '#ffcc00',
      },
    },
    noSetup: {
      opacity: 1,
      background: '#ffcc00',
      color: '#000000',
      animationName: 'yellowPulse',
      animationIterationCount: 'infinite',
      animationDuration: '2s',
      '&:hover': {
        backgroundColor: '#ffcc00',
      },
    },
    '@keyframes yellowPulse': {
      '0': {
        opacity: 0.4,
      },
      '50%': {
        opacity: 0.7,
      },
      '100%': {
        opacity: 1,
      },
    },
    extendedIcon: {
      marginRight: 5,
    },
    popper: {
      opacity: 1,
    },
    tooltipError: {
      position: 'relative',
      width: 300,
      padding: 16,
      background: '#fff',
      color: '#000',
      boxShadow: '0 1px 4px 0 rgba(255, 59, 48, .3)',
      '&:before': {
        content: "''",
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: -11,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 11px 10px 11px',
        borderColor:
          'transparent transparent rgba(255, 59, 48, 0.1) transparent',
      },
      '& $tooltipItems': {
        '&::-webkit-scrollbar-track': {
          borderRadius: 2,
          backgroundColor: '#fff',
        },
        '&::-webkit-scrollbar': {
          width: 3,
          backgroundColor: '#fff',
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
          backgroundColor: 'rgba(255, 59, 48, 0.1)',
        },
      },
    },
    tooltipWarning: {
      position: 'relative',
      width: 300,
      padding: 16,
      background: '#fff',
      color: '#000',
      boxShadow: '0 1px 4px 0 rgba(255, 204, 0, .3)',
      '&:before': {
        content: "''",
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: -11,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 11px 10px 11px',
        borderColor:
          'transparent transparent rgba(255, 204, 0, .3) transparent',
      },
      '& $tooltipItems': {
        '&::-webkit-scrollbar-track': {
          borderRadius: 2,
          backgroundColor: '#fff',
        },
        '&::-webkit-scrollbar': {
          width: 3,
          backgroundColor: '#fff',
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
          backgroundColor: 'rgba(255, 204, 0, .3) ',
        },
      },
    },
    tooltipItems: {
      listStyleType: 'decimal',
      pointerEvents: 'auto',
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: 250,
      padding: '0 15px',
      '& li': {
        marginBottom: 4,
      },
      '& span': {
        display: 'block',
      },
      '& a': {
        color: '#000',
        textDecoration: 'underline',
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
  }
})
